import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import FormRow from 'modules/core/components/FormRow'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'
import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
  onEmployeeSelectionChange: (selector: EmployeeSelectorV2MultiSelectState) => void
}

const ExportEmployeeSelector = ({ form, onEmployeeSelectionChange }: Props) => {
  const [employeeSelection, setEmployeeSelection] =
    React.useState<EmployeeSelectorV2MultiSelectState>({
      type: 'manual',
      ids: [],
    })

  useEffect(() => {
    form.setValues({
      employee_ids: employeeSelection.type === 'manual' ? employeeSelection.ids : [],
    })
    onEmployeeSelectionChange(employeeSelection)
    // @ts-expect-error - form and onEmployeeSelectionChange are stable but linter has false positive
  }, [employeeSelection, form, onEmployeeSelectionChange])

  return (
    <>
      <FormRow>
        <Box className="sidebar_employees_export_employee_data_timeoff_employees_button">
          <EmployeeSelectorV2
            messages={{
              placeholder: i18n.t('employees.reports.employees'),
            }}
            onChange={(state) => {
              setEmployeeSelection(state)
            }}
            multiple
          />
        </Box>
      </FormRow>
    </>
  )
}

export default ExportEmployeeSelector
